import React from 'react'

export default function Bold() {
    return (
        <svg
            height='100%'
            viewBox='0 0 36 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M24.532 16.9242C25.7133 15.6937 26.4375 14.0309 26.4375 12.2027V11.8441C26.4375 8.06133 23.3402 4.99219 19.5223 4.99219H9.11953C8.58867 4.99219 8.15625 5.42461 8.15625 5.95547V29.8301C8.15625 30.4031 8.62031 30.8672 9.19336 30.8672H20.3977C24.5109 30.8672 27.8438 27.5555 27.8438 23.4668V23.0801C27.8438 20.5137 26.5289 18.2531 24.532 16.9242ZM11.5312 8.36719H19.4309C21.4383 8.36719 23.0625 9.92812 23.0625 11.8582V12.1922C23.0625 14.1187 21.4348 15.6832 19.4309 15.6832H11.5312V8.36719ZM24.4195 23.4633C24.4195 25.6746 22.602 27.4676 20.359 27.4676H11.5312V19.0793H20.359C22.602 19.0793 24.4195 20.8723 24.4195 23.0836V23.4633Z'
                fill='black'
            />
        </svg>
    )
}
